import { MsLoupe as p } from "@sunrise/icons";
import { screenSizeDetection as y, urlUtils as d } from "@sunrise/shared";
import { track as s, NOT_SET as t } from "@sunrise/tracking";
import { AutocompleteDropdown as o } from "@sunrise/types";
import { defineComponent as f } from "vue";
import g from "./index37.js";
import h from "./index33.js";
import b from "./index148.js";
const k = f({
  name: "MsHeaderRelocation",
  components: {
    MsButton: b,
    MsLoupe: p,
    CsPrimaryButton: g,
    CsLocationAutocomplete: h
  },
  setup() {
    const { isScreenL: l } = y();
    let r, a;
    const m = {
      mslayer_element_data_id: "ed0000004",
      mslayer_element_text: t,
      mslayer_element_type_text: "RelocationSiloHeader",
      mslayer_element_count: t,
      mslayer_element_body_type: "text_body",
      mslayer_element_position: t,
      mslayer_element_id: t,
      mslayer_affiliate_id: t,
      mslayer_element_company_name: "default",
      mslayer_element_detail_start_date: t,
      mslayer_channel_search_channel_combo: t
    };
    function _(e) {
      a = e;
    }
    function c(e) {
      r = e.location, e.type !== o.SuggestionEmitValueTypes.TAB && i(e.type);
    }
    function u(e) {
      switch (e) {
        case o.SuggestionEmitValueTypes.CLICK:
          return "suggestion_submit";
        case o.SuggestionEmitValueTypes.ENTER:
          return "keypress_submit";
        default:
          return "button_submit";
      }
    }
    function i(e) {
      const n = r || a;
      n && (s({
        ...m,
        mslayer_element_variant: u(e),
        mslayer_element_text: "Ort auswählen"
      }), s({
        ...m,
        mslayer_element_variant: "autocomplete_submit",
        mslayer_channel_search_searchphrases: n.name,
        mslayer_element_text: t
      }), d.redirect(window.location.href, {
        action: "relocation",
        words: n.id
      }));
    }
    return {
      onHighlighted: _,
      onSelect: c,
      redirect: i,
      isScreenL: l
    };
  }
});
export {
  k as default
};
